import UltMeta, { Meta } from "./UltMeta";

/**
 * 收费项
 */
class StorageFeeType extends UltMeta {
    INBOUND = new Meta(1, "入库费");
    OUTBOUND = new Meta(2, "出库费");
    TRANSFER = new Meta(3, "过户费");
}

export const STORAGE_FEE_TYPE = new StorageFeeType();
